module.exports = __webpack_public_path__ + "de77a722/img/comment-question-icon.7dd26e04.svg";